import { Component, OnInit } from "@angular/core";
import { ValidateTokenService } from "../services/validate-token.service";
import { AuthenticationService } from "../auth/authentication.service";
import { NavigationEnd, Router } from "@angular/router";

@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.css'],
})


export class InvoicesComponent implements OnInit {
  constructor(){  }

  ngOnInit(): void { }
}

